import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { 
  Package, // For Quality
  Settings, // For Versatility
  Recycle, // For Eco-Friendly
  Shield // For Protection
} from 'lucide-react';

const ProductCategory2 = () => {
  const features = [
    {
      icon: Package,
      title: "Premium Quality",
      description: "High-grade materials and superior construction ensure reliable performance for all packaging needs.",
      bgColor: "#4CAF50" // Green for quality
    },
    {
      icon: Settings,
      title: "Versatile Design",
      description: "Adaptable packaging solutions suitable for various industries and applications, from retail to industrial use.",
      bgColor: "#FF9800" // Orange for versatility
    },
    {
      icon: Recycle,
      title: "Eco-Conscious",
      description: "Sustainable packaging options made from recyclable materials, minimizing environmental impact while maximizing efficiency.",
      bgColor: "#2196F3" // Blue for eco-friendly
    },
    {
      icon: Shield,
      title: "Protection Guaranteed",
      description: "Enhanced protective features ensure contents remain secure and undamaged during storage and transportation.",
      bgColor: "#9C27B0" // Purple for protection
    }
  ];

  return (
    <div className="container py-5">
      <div className="text-center mb-5">
        <h2 className="main-heading display-5 fw-bold mb-3">Discover Features</h2>
        <p className="product-each-desc text-muted mx-auto" style={{ maxWidth: '700px' }}>
          Professional-grade packaging solutions combining innovative design, durability, and sustainability to meet diverse industrial and commercial requirements, ensuring optimal protection and efficiency.
        </p>
      </div>

      <div className="row g-4">
        {features.map((feature, index) => {
          const IconComponent = feature.icon;
          return (
            <div key={index} className="col-12 col-sm-6 col-lg-3">
              <div className="card h-100 border-0 shadow-sm feature-card">
                <div className="text-center mt-4">
                  <div 
                    className="icon-container d-inline-flex align-items-center justify-content-center rounded-3 mb-4"
                    style={{ background: feature.bgColor }}
                  >
                    <IconComponent size={40} className="icon-img" />
                  </div>
                </div>
                
                <div className="card-body text-center">
                  <h3 className="card-title h5 mb-3">{feature.title}</h3>
                  <p className="card-text text-muted mb-4">{feature.description}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <style>
        {`
          .feature-card {
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
          }

          .feature-card::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 0;
            height: 3px;
            background-color: #dc3545;
            transition: width 0.3s ease;
          }

          .feature-card:hover {
            transform: translateY(-10px);
          }

          .feature-card:hover::after {
            width: 100%;
          }

          .icon-container {
            width: 80px;
            height: 80px;
            transition: all 0.3s ease;
          }

          .icon-img {
            color: white;
          }

          .feature-card:hover .icon-container {
            transform: scale(1.1);
          }
        `}
      </style>
    </div>
  );
};

export default ProductCategory2;